export function sendNotification(message: string) {
    const notification = new Notification('Notification', {
        body: message,
    });
    notification.onclick = () => {
        console.log('Notification clicked!');
    };
}